import React from 'react';
import CustomPage from 'src/components/CustomPage';

const PrivacyPolicy: React.FC = () => {
  return <CustomPage pageType="pp" pageName="PrivacyPolicy" />;
};

export default PrivacyPolicy;
